import React from 'react';
import 'react-toastify/dist/ReactToastify.css'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

function FullNews({ list }) {
    return (
        <>
            {list.map((item, index) => (
                <>
                    <div className='flex space-x-6 mx-auto my-auto h-sm:hidden'>
                        <div className='flex h-full' style={{ width: '900px' }}>

                            <div style={{ width: '390px' }}>
                                <img src="us_news.png" alt="logo" />
                            </div>
                            <div style={{ width: '510px' }} className='p-5 pt-0'>
                                <div>
                                    <span style={{ color: '#f5be88' }}>Para você</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-3xl font-extrabold font-raleway'>{item.title}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-sm'>{item.text}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-sm'>{item.subText}</span>
                                </div>
                                <Link to={"/" + item.link}>
                                    <div className="mt-4 h-8 rounded-sm flex items-center justify-center" style={{ backgroundColor: '#c76f36' }}>
                                        <span className="text-base text-white" >Saiba mais</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    {/* Componente responsivo para celular */}
                    <div className='flex mx-auto my-auto h-sm:flex hidden px-4'>
                        <div className='h-full w-full'>

                            <div className='w-full h-full'>
                                <img src="us_howMuch-mobile.png" alt="logo" className='w-full' />
                            </div>
                            <div className='w-full h-full mt-2'>
                                <div>
                                    <span style={{ color: '#f5be88' }}>Para você</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-3xl font-extrabold font-raleway'>{item.title}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-sm'>{item.text}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='text-sm'>{item.subText}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ))}

        </>
    );
}

export default FullNews;